import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=7ed24ff8&scoped=true&"
import script from "./ChainList.vue?vue&type=script&lang=js&"
export * from "./ChainList.vue?vue&type=script&lang=js&"
import style0 from "./ChainList.vue?vue&type=style&index=0&id=7ed24ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed24ff8",
  null
  
)

export default component.exports